import { IonButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useRef, useState } from 'react';

import { getFakeAccessToken, getExpiredToken, postRefresh } from '../../api/portal/auth.api';
import { IJwt } from '../../models/portal/auth.model';
import { sqlite } from '../../sqlite/sqlConnectionProvider';
import store from '../../store';
import { setIsAuthenticatedStoreAsync, setTokenStoreAsync } from '../../store/authSlice';
import { increment } from '../../store/counterSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export interface IComponentProps {}

const SandboxPage: React.FC<IComponentProps> = function () {
  const dispatch = useAppDispatch();

  const { value } = useAppSelector((state) => state.counter);
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const { token } = useAppSelector((state) => state.auth);
  const [log, setLog] = useState<string[]>([]);
  const errMess = useRef('');

  const sqliteTest = async () => {
    // test the plugin with echo
    let res: any = await sqlite.echo('Hello from echo');
    if (res.value !== 'Hello from echo') {
      errMess.current = `Echo not returning "Hello from echo"`;
      return false;
    }
    setLog((log) => log.concat('> Echo successful\n'));

    setLog((log) => log.concat(`> Deleting db\n`));
    let db = await sqlite.createConnection(process.env.REACT_APP_DBNAME!);
    if (await db.isExists) {
      await db.delete();
    }

    // create tables in db
    setLog((log) => log.concat(`> Creating table\n`));
    await db.open();
    let ret: any = await db.execute(createSchema112, false);
    if (ret.changes.changes < 0) {
      errMess.current = `Execute 1: createSchema failed"`;
      return false;
    }
    await db.close();

    await sqlite.closeConnection(process.env.REACT_APP_DBNAME!);
  };

  const expireToken = async () => {
    const expiredToken = getExpiredToken(token || ({} as IJwt));
    await dispatch(
      setTokenStoreAsync({
        ...token,
        access_token: expiredToken,
      } as IJwt),
    );
  };

  const spamFail = async () => {
    await expireToken();
  };

  const refreshToken = async () => {
    const newToken = await postRefresh(token?.refresh_token || 'UNKNOWN_REFRESHTOKEN', token?.databaseId || 'UNKNOWN_DBID');
    if (newToken.access_token) {
      await dispatch(setTokenStoreAsync(newToken));
    }
  };

  const killRefreshToken = async () => {
    const token = store.getState().auth.token;
    const expiredToken = getExpiredToken(token || ({} as IJwt));
    await dispatch(
      setTokenStoreAsync({
        ...token,
        access_token: expiredToken,
        refresh_token: 'INVALID_REFRESHTOKEN',
      } as IJwt),
    );
  };

  const killToken = async () => {
    const invalidToken = getFakeAccessToken(token?.databaseId || 'UNKNOWN_DBID');
    await dispatch(
      setTokenStoreAsync({
        ...token,
        access_token: invalidToken,
        refresh_token: 'INVALID_REFRESHTOKEN',
      } as IJwt),
    );
  };

  const showToken = () => {
    const tokenData = {
      access_token: '...',
      contactCode: token?.contactCode,
      databaseId: token?.databaseId,
      displayUsername: token?.displayUsername,
      moduleCode: token?.moduleCode,
      userName: token?.userName,
    } as IJwt;
    alert(JSON.stringify(tokenData));
  };

  return (
    <IonPage>
      <IonHeader color="lightest">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="secondary" />
          </IonButtons>
          <IonTitle>Sandbox</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent color="lightest">
        <IonButton expand="full" onClick={() => dispatch(increment())}>
          Increment {value}
        </IonButton>
        <IonButton expand="full" onClick={() => dispatch(setIsAuthenticatedStoreAsync(!isAuthenticated))}>
          IsAuthenticated: {isAuthenticated ? 'true' : 'false'}
        </IonButton>
        <IonButton expand="full" onClick={() => sqliteTest()}>
          Sqlite Test
        </IonButton>
        <IonButton expand="full" onClick={() => expireToken()}>
          Expire Token
        </IonButton>
        <IonButton expand="full" onClick={() => refreshToken()}>
          Refresh Token
        </IonButton>
        <IonButton expand="full" onClick={() => spamFail()}>
          Auto Refresh Token
        </IonButton>
        <IonButton expand="full" onClick={() => killToken()}>
          Kill Token
        </IonButton>
        <IonButton expand="full" onClick={() => killRefreshToken()}>
          Kill Refresh Token
        </IonButton>
        <IonButton expand="full" onClick={() => showToken()}>
          Show Token
        </IonButton>

        {log}
      </IonContent>
    </IonPage>
  );
};

export default SandboxPage;

const createSchema112: string = `
CREATE TABLE IF NOT EXISTS teachers (
    id INTEGER PRIMARY KEY NOT NULL,
    email VARCHAR(255) UNIQUE NOT NULL,
    name VARCHAR(50),
    office TEXT,
    size DOUBLE,
    age INT,
    phone DECIMAL(11,0),
    birth_date DATE,
    last_modified INTEGER DEFAULT (strftime('%s', 'now'))
);
CREATE INDEX IF NOT EXISTS teachers_index_email ON teachers (email);
CREATE INDEX IF NOT EXISTS teachers_index_last_modified ON teachers (last_modified);
CREATE TRIGGER IF NOT EXISTS teachers_trigger_last_modified
AFTER UPDATE ON teachers
FOR EACH ROW WHEN NEW.last_modified <= OLD.last_modified
BEGIN
    UPDATE teachers SET last_modified= (strftime('%s', 'now')) WHERE id=OLD.id;
END;
`;
